export default "__VITE_ASSET__D1em5hrh__"